<template>
  <div @mousemove="emit(true)" @mouseleave="emit(false)">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['value'],
  methods: {
    emit(value) {
      if (value !== this.value)
        this.$emit('input', value);
    },
  },
}
</script>